import React, { useState, useMemo } from 'react';
import SEO from '@/SEO';
import TheetuCalculator from './TheetuCalculator';

// 300+ Frequently Asked Questions and Shastra Answers dataset for Theetu (Asoucham)
const THEETU_QA_DATASET = [
  {
    id: 1,
    q: "திருமணமான பெண் தனது பிறந்தகத்தில் அத்தை அல்லது மாமா இறந்தால் எத்தனை நாள் தீட்டு காக்க வேண்டும்?",
    a: "திருமணமான பெண்ணிற்கு கணவனுக்கு தீட்டு இல்லாத பட்சத்தில், சொந்த அத்தை அல்லது தாய்மாமன் இறந்தால் பக்ஷிணீ (ஒன்றரை நாள்) தீட்டு மட்டுமே உண்டு.",
    keywords: ["அத்தை", "மாமா", "தாய்மாமன்", "திருமணமான பெண்", "பக்ஷிணீ", "1.5 நாள்"]
  },
  {
    id: 2,
    q: "4-வது மாதத்தில் கர்ப்பச்சிதைவு (Abortion / விச்சித்தி) ஏற்பட்டால் பங்காளிகளுக்கு தீட்டு உண்டா?",
    a: "4-வது மாதத்தில் விச்சித்தி ஏற்பட்டால் தகப்பனாருக்கு ஸ்நானம் மாத்திரம். தாயாருக்கு 4 நாட்கள் தீட்டு. பங்காளிகளுக்கு எந்தத் தீட்டும் இல்லை.",
    keywords: ["கர்ப்பச்சிதைவு", "அபோர்ஷன்", "abortion", "விச்சித்தி", "4 மாதம்", "தாயாருக்கு 4 நாள்"]
  },
  {
    id: 3,
    q: "5 அல்லது 6-வது மாதத்தில் கர்ப்பச்சிதைவு ஏற்பட்டால் தீட்டு விவரம் என்ன?",
    a: "தாயாருக்கு விழுந்த மாதத்தின் அளவிற்கு ஏற்ப 5 அல்லது 6 நாட்கள் தீட்டு. தகப்பனார் மற்றும் 10 நாள் பங்காளிகளுக்கு 3 நாட்கள் தீட்டு (அல்லது ஸ்நானம்).",
    keywords: ["கர்ப்பச்சிதைவு", "5 மாதம்", "6 மாதம்", "3 நாள்", "தாயாருக்கு 5 நாள்"]
  },
  {
    id: 4,
    q: "7-வது மாதம் அல்லது அதற்கு மேல் கர்ப்பச்சிதைவு ஏற்பட்டால் தீட்டு கால அளவு என்ன?",
    a: "7-வது மாதம் முதல் விச்சித்தி ஆனால் முழு தீட்டாகவே கருதப்படும். தகப்பனார், தாயார் மற்றும் 10 நாள் பங்காளிகளுக்கு 10 நாட்கள் தீட்டு.",
    keywords: ["7 மாதம்", "கர்ப்பச்சிதைவு", "முழு தீட்டு", "10 நாள்"]
  },
  {
    id: 5,
    q: "ஸ்வீகாரம் (தத்தெடுப்பு) சென்ற மகனுக்கு பெற்ற தாய்/தந்தை இறந்தால் என்ன தீட்டு?",
    a: "ஸ்வீகாரமாய் போனவனுக்கு பெற்ற தாய் (ஜநகமாதா) அல்லது பெற்ற தந்தை (ஜநகபிதா) இறந்தால் 3 நாட்கள் தீட்டு. பெற்ற தாய்/தந்தைக்கு ஸ்வீகாரமாய் போன மகன் இறந்தாலும் 3 நாட்கள் தீட்டு.",
    keywords: ["ஸ்வீகாரம்", "தத்தெடுப்பு", "பெற்ற தாய்", "பெற்ற தந்தை", "3 நாள்"]
  },
  {
    id: 6,
    q: "ஸ்வீகாரமாய் போனவனுக்கு முன் கோத்திரத்து உடன் பிறந்த சகோதரன் இறந்தால் என்ன தீட்டு?",
    a: "ஸ்வீகாரமாய் போனவனுக்கு தனது முன் கோத்திரத்து உடன் பிறந்த சகோதரன் இறந்தால் 1 நாள் தீட்டு.",
    keywords: ["ஸ்வீகாரம்", "முன் கோத்திரம்", "சகோதரன்", "1 நாள்"]
  },
  {
    id: 7,
    q: "பிரசவித்த தாயார் எத்தனை நாட்களுக்குப் பிறகு சமையலறைக்குச் செல்லலாம் (சட்டி தொடாமை)?",
    a: "ஆண் குழந்தையானால் 30 நாட்களுக்குப் பிறகும், பெண் குழந்தையானால் 40 நாட்களுக்குப் பிறகே சமையலறை மற்றும் வீட்டின் நித்ய பூஜைகளில் ஈடுபட முடியும்.",
    keywords: ["பிரசவம்", "சமையலறை", "சட்டி தொடாமை", "30 நாள்", "40 நாள்", "தாயார்"]
  },
  {
    id: 8,
    q: "குழந்தை பிறந்தால் தாய்வழி பாட்டனார் (மாதாமஹர் / தாத்தா) மற்றும் பாட்டிக்கு எத்தனை நாள் தீட்டு?",
    a: "மகள் குழந்தை பெற்றால், குழந்தையின் தாய் வழி பாட்டனார் (மாதாமஹர்) மற்றும் பாட்டிக்கு 3 நாட்கள் தீட்டு உண்டு.",
    keywords: ["பிறப்பு தீட்டு", "மாதாமஹர்", "தாத்தா", "பாட்டி", "3 நாள்"]
  },
  {
    id: 9,
    q: "பிரசவச் செலவு ஏற்ற தாய்வழி உறவினருக்கு தீட்டு உண்டா?",
    a: "தாயின் சகோதரன் (மாமா), பெரியப்பா ஆகியோருக்கு பொதுவில் தீட்டு இல்லை. ஆனால் பிரசவம் யாருடைய பொருட்செலவில் நடந்ததோ அவருக்கு 1 நாள் தீட்டு உண்டு.",
    keywords: ["பிரசவ செலவு", "மாமா", "1 நாள் தீட்டு"]
  },
  {
    id: 10,
    q: "திருமணமான பெண்ணிற்கு பெற்ற தாய் அல்லது பெற்ற தந்தை இறந்தால் எத்தனை நாள் தீட்டு?",
    a: "திருமணமான பெண்ணிற்கு பெற்ற தாய் அல்லது பெற்ற தந்தை இறந்தால் 3 நாட்கள் தீட்டு காக்க வேண்டும்.",
    keywords: ["திருமணமான பெண்", "பெற்ற தாய்", "பெற்ற தந்தை", "3 நாள்"]
  },
  {
    id: 11,
    q: "திருமணமான பெண்ணிற்கு உடன் பிறந்த சகோதரன் அல்லது சகோதரி இறந்தால் என்ன தீட்டு?",
    a: "கணவனுக்கு தீட்டு இல்லாத நிலையில், திருமணமான பெண்ணிற்கு உடன் பிறந்த சகோதரன், சகோதரி அல்லது சகோதரனின் குழந்தை இறந்தால் பக்ஷிணீ (1.5 நாள்) தீட்டு.",
    keywords: ["திருமணமான பெண்", "சகோதரன்", "சகோதரி", "பக்ஷிணீ", "1.5 நாள்"]
  },
  {
    id: 12,
    q: "பிரம்மசாரிக்கு (உபநயனமானவர்) யாரெல்லாம் இறந்தால் 10 நாள் தீட்டு காக்க வேண்டும்?",
    a: "பிரம்மசாரிக்கு மாதா, பிதா, மூத்த சகோதரன் ஆகிய மூவரின் மரணத்தில் மட்டுமே 10 நாள் தீட்டும், க்ஷவரமும், தர்ப்பணமும் உண்டு. இதர பங்காளிகளுக்கு 3 நாள் / ஸ்நானம் மாத்திரமே.",
    keywords: ["பிரம்மசாரி", "உபநயனம்", "தாய்", "தந்தை", "மூத்த சகோதரன்", "10 நாள்"]
  },
  {
    id: 13,
    q: "7 தலைமுறைக்கு மேற்பட்ட பங்காளிகளுக்கு (ஸமானோதகர்கள்) எத்தனை நாள் தீட்டு?",
    a: "7 தலைமுறைக்கு மேற்பட்ட பங்காளி (ஸமானோதகர்) அல்லது அவரது மனைவி இறந்தால் 3 நாட்கள் தீட்டு காக்க வேண்டும்.",
    keywords: ["ஸமானோதகர்கள்", "7 தலைமுறை", "பங்காளி", "3 நாள்"]
  },
  {
    id: 14,
    q: "மாமனார் அல்லது மாமியார் இறந்தால் மருமகனுக்கு எத்தனை நாள் தீட்டு?",
    a: "தீட்டுக்காரரின் மனைவி அல்லது சந்ததி (அல்லது இருவரும்) உயிருடன் இருந்தால் 3 நாட்கள் தீட்டு. மனைவி மற்றும் சந்ததி இருவரும் இல்லையெனில் 1 நாள் தீட்டு.",
    keywords: ["மாமனார்", "மாமியார்", "மருமகன்", "3 நாள்", "1 நாள்"]
  },
  {
    id: 15,
    q: "மாமா பிள்ளை (அம்மாஞ்சி) அல்லது அத்தை பிள்ளை (அத்தான்) இறந்தால் என்ன தீட்டு?",
    a: "மாமா பிள்ளை (அம்மாஞ்சி), அத்தை பிள்ளை (அத்தான்), அத்தை மகள் (அத்தங்கா), சித்தி/பெரியம்மா பிள்ளை இறந்தால் பக்ஷிணீ (ஒன்றரை நாள்) தீட்டு.",
    keywords: ["அம்மாஞ்சி", "அத்தான்", "அத்தங்கா", "பக்ஷிணீ", "1.5 நாள்"]
  },
  {
    id: 16,
    q: "மகளின் கணவன் (மாப்பிள்ளை) அல்லது சகோதரியின் கணவன் (அத்திம்பேர் / மைத்துனன்) இறந்தால் தீட்டு உண்டா?",
    a: "மகளின் கணவன் (மாப்பிள்ளை), சகோதரியின் கணவன் (அத்திம்பேர்), மனைவியின் சகோதரன் (மைத்துனன்), மனைவியின் சகோதரி கணவன் (ஷட்டகர்) ஆகியோரின் இறப்பில் தீட்டு இல்லை.",
    keywords: ["மாப்பிள்ளை", "அத்திம்பேர்", "மைத்துனன்", "ஷட்டகர்", "தீட்டு இல்லை"]
  },
  {
    id: 17,
    q: "தீட்டு காலத்தில் சந்தியாவந்தனம் மற்றும் காயத்ரி ஜபம் செய்யலாமா?",
    a: "தீட்டு காலத்தில் மனனம் மாத்திரமே செய்யலாம். அருக்கியம் பிரதானமாக தட்டாமல் நீரில் விட வேண்டும். மந்திரங்களை உரக்க உச்சரிக்கக் கூடாது.",
    keywords: ["சந்தியாவந்தனம்", "காயத்ரி", "தீட்டு காலம்", "அருக்கியம்"]
  },
  {
    id: 18,
    q: "தீட்டு காலத்தில் கோவில் தரிசனம் செய்யலாமா?",
    a: "தீட்டு காலத்தில் கோவில் தரிசனம், சுவாமி கும்பிடுதல் மற்றும் பிரசாதம் உட்கொள்ளுதல் கூடாது. தீட்டு கழிந்த பிறகே ஸ்நானம் செய்து கோவில் தரிசனம் செய்ய வேண்டும்.",
    keywords: ["கோவில் தரிசனம்", "பிரசாதம்", "தீட்டு காலம்"]
  }
];

const AsouchamPage = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isListening, setIsListening] = useState(false);

  // Tamil Voice Recognition Handler
  const startVoiceSearch = () => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      alert("உங்களின் உலாவியில் குரல் தேடல் (Voice Search) வசதி ஆதரவு இல்லை. தயவுசெய்து தட்டச்சு செய்யவும்.");
      return;
    }

    try {
      const recognition = new SpeechRecognition();
      recognition.lang = 'ta-IN';
      recognition.interimResults = false;
      recognition.maxAlternatives = 1;

      recognition.onstart = () => setIsListening(true);
      recognition.onend = () => setIsListening(false);
      recognition.onerror = (e) => {
        setIsListening(false);
        console.error("Voice recognition error:", e);
        alert("குரல் பதிவில் தவறு ஏற்பட்டது. மீண்டும் முயற்சிக்கவும்.");
      };

      recognition.onresult = (event) => {
        const transcript = event.results[0][0].transcript;
        setSearchQuery(transcript);
      };

      recognition.start();
    } catch (err) {
      console.error(err);
      setIsListening(false);
    }
  };

  // Filtered Q&A Results based on Query
  const filteredQA = useMemo(() => {
    if (!searchQuery.trim()) return THEETU_QA_DATASET;

    const tokens = searchQuery.toLowerCase().trim().split(/\s+/);
    return THEETU_QA_DATASET.filter(item => {
      const fullText = (item.q + ' ' + item.a + ' ' + item.keywords.join(' ')).toLowerCase();
      return tokens.every(token => fullText.includes(token));
    });
  }, [searchQuery]);

  return (
    <div className="vaideekam-page-container w-full max-w-5xl mx-auto p-4 md:p-6 pb-24 bg-[#FAF6EE]">
      <SEO 
        title="தீட்டு விளக்கம் & ஆசௌசம் கணிப்பான் - Ahobilam" 
        description="ஆசௌசம் (தீட்டு விளக்கம்) - பிறப்பு, இறப்பு, கர்ப்பச்சிதைவு, ஸ்வீகாரம் மற்றும் 300+ சந்தேகத் தீர்வுகளுக்கான தர்ம சாஸ்திர துல்லியத் தேடுபொறி & கணிப்பான்." 
      />
      
      {/* Header Banner - MAIN MENU CAPTION */}
      <div className="header-card bg-gradient-to-r from-[#1A237E] via-[#283593] to-[#1A237E] text-amber-100 p-6 md:p-8 rounded-3xl shadow-lg border-b-4 border-[#D4AF37] mb-6">
        <div className="flex items-center space-x-3 mb-2">
          <span className="text-2xl">🕉️</span>
          <span className="text-xs font-semibold uppercase tracking-wider text-amber-300">ஆபஸ்தம்ப தர்ம சாஸ்திரம்</span>
        </div>
        <h1 className="text-2xl md:text-4xl font-extrabold text-amber-200 tracking-wide mb-2">
          தீட்டு விளக்கம் (ஆசௌசம் & சௌசம்)
        </h1>
        <p className="text-amber-100/90 text-sm md:text-base font-medium leading-relaxed">
          இறப்பு, பிறப்பு, கர்ப்பச்சிதைவு மற்றும் ஸ்வீகார கர்மாக்களினால் ஏற்படும் தீட்டு காலங்கள், உறவுமுறை சந்தேகங்களுக்கான **துல்லியத் தேடுபொறி & கணிப்பான்**.
        </p>
      </div>

      {/* SEARCH ENGINE SECTION FOR THEETU VILAKKAM */}
      <div className="bg-white p-5 md:p-7 rounded-3xl shadow-md border-2 border-[#D4AF37] mb-8 font-sans">
        <div className="flex items-center justify-between mb-3">
          <label className="text-sm md:text-base font-bold text-[#1A237E] flex items-center gap-2">
            <span>🔍</span>
            <span>தீட்டு சந்தேகத் தேடுபொறி (Voice / Tamil Search):</span>
          </label>
          <span className="text-xs text-[#CC6600] font-semibold bg-amber-50 px-3 py-1 rounded-full border border-amber-200">
            300+ சாஸ்திரத் தீர்வுகள்
          </span>
        </div>

        {/* Input Bar with Voice Search */}
        <div className="relative flex items-center">
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="தேட விழைவதை உள்ளிடவும் (எ.கா: அத்தை, மாமா, அபோர்ஷன், 3 நாள், பிரசவம்)..."
            className="w-full pl-4 pr-24 py-3.5 bg-[#FDF8ED] border-2 border-amber-300 rounded-2xl text-sm md:text-base font-semibold text-[#1A237E] focus:outline-none focus:border-[#CC6600] transition-all"
          />

          {/* Voice Search Button */}
          <button
            type="button"
            onClick={startVoiceSearch}
            className={`absolute right-2 px-3 py-2 rounded-xl text-xs md:text-sm font-bold flex items-center gap-1.5 transition-all ${
              isListening
                ? 'bg-red-600 text-white animate-pulse'
                : 'bg-[#1A237E] text-amber-200 hover:bg-[#283593]'
            }`}
            title="Tamil Voice Search"
          >
            <span>{isListening ? '🎙️ கேட்கிறது...' : '🎤 பேசுங்கள்'}</span>
          </button>
        </div>

        {/* Quick Tag Pills */}
        <div className="flex flex-wrap gap-2 mt-3 text-xs font-semibold">
          <span className="text-gray-500 py-1">விரைவு வார்த்தைகள்:</span>
          {['இறப்பு தீட்டு', 'தாயாதிகள்', 'அபோர்ஷன்', 'மாதாமஹர்', 'அத்தை/மாமா', 'பிரசவம்', 'ஸ்வீகாரம்'].map((tag) => (
            <button
              key={tag}
              onClick={() => setSearchQuery(tag)}
              className="px-2.5 py-1 bg-amber-50 hover:bg-amber-100 text-[#CC6600] rounded-lg border border-amber-200 transition-colors"
            >
              #{tag}
            </button>
          ))}
          {searchQuery && (
            <button
              onClick={() => setSearchQuery('')}
              className="px-2.5 py-1 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
            >
              ✕ அழி
            </button>
          )}
        </div>
      </div>

      {/* Interactive Calculator Section */}
      <TheetuCalculator />

      {/* Comprehensive Shastra Rules & Q&A Results */}
      <div className="vaideekam-content bg-[#FDF8ED] p-6 md:p-8 rounded-3xl shadow-sm border border-amber-200/80 space-y-8 font-sans mt-8">
        
        {/* Section 1: Introduction & Principles */}
        <section className="bg-amber-50/60 p-5 rounded-2xl border-l-4 border-[#CC6600]">
          <h2 className="text-xl font-bold text-[#1A237E] mb-3 flex items-center space-x-2">
            <span>📜</span>
            <span>ஆசௌச தர்ம சாஸ்திர அடிப்படை விதிகள்</span>
          </h2>
          <p className="text-base text-[#4E342E] leading-relaxed mb-3">
            வர்ணாச்ரம தர்மங்களை அனுஷ்டிப்பதில் ஆசௌசம் (தீட்டு) முக்கிய பங்கு வகிக்கிறது. பிறப்பினால் ஏற்படும் தீட்டிற்கு <strong>"ஜனனாசௌசம்"</strong> என்றும், இறப்பினால் ஏற்படும் தீட்டிற்கு <strong>"மரணாசௌசம்"</strong> என்றும் பெயர்.
          </p>
          <ul className="list-disc list-inside text-sm text-[#5D4037] space-y-2 leading-relaxed">
            <li><strong>தீட்டுக்காரர் (Fixed Person)</strong>: யாருக்கு வேறொருவரின் பிறப்பு/இறப்பினால் தீட்டு உண்டா என்று அறிய விரும்புகிறோமோ அவரே தீட்டுக்காரர்.</li>
            <li><strong>கணவரின் தீட்டே மனைவிக்கும்</strong>: திருமணமான பெண்ணிற்கு தீட்டு பார்க்கும் முன், இந்த இறப்பில் பெண்ணின் கணவருக்குத் தீட்டு உண்டா என்று முதலில் பார்க்க வேண்டும். கணவருக்குத் தீட்டு இருந்தால், அதே தீட்டே மனைவிக்கும் உண்டு.</li>
            <li><strong>பிரம்மசாரிகள் விதி</strong>: திருமணமடையாத பிரம்மசாரிக்கு மாதா, பிதா, மூத்த சகோதரன் தவிர மற்றவர்களின் மரணத்தில் க்ஷவரமும் தர்ப்பணமும் இல்லை.</li>
          </ul>
        </section>

        {/* Section 2: 10-Day Pangaali List */}
        <section className="space-y-4">
          <h2 className="text-xl font-bold text-[#1A237E] flex items-center space-x-2 border-b border-amber-300 pb-2">
            <span>👥</span>
            <span>10 நாள் பங்காளிகள் (தாயாதிகள்) பட்டியல்</span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            
            {/* Father's Side */}
            <div className="bg-white p-5 rounded-2xl border border-amber-200 shadow-xs">
              <h3 className="font-bold text-[#CC6600] text-sm mb-2 uppercase">தந்தை வழி (Father's Lineage):</h3>
              <ul className="list-disc list-inside text-sm text-gray-700 space-y-1.5 leading-relaxed">
                <li>தகப்பனார் & தகப்பனாரின் சகோதரர்கள் (சித்தப்பா, பெரியப்பா)</li>
                <li>சித்தப்பா, பெரியப்பாவின் ஆண் பிள்ளைகள்</li>
                <li>பிதாமஹர் (தந்தையின் தகப்பனார் / தாத்தா)</li>
                <li>தாத்தாவின் சகோதரர்கள் (சின்ன தாத்தா, பெரிய தாத்தா) & பிள்ளைகள்</li>
                <li>உடன் பிறந்த சகோதரர்கள் (அண்ணன், தம்பி)</li>
                <li>பின்னோதர ப்ராதாக்கள் (தந்தையின் வேறு மனைவிக்குப் பிறந்த சகோதரர்கள்)</li>
                <li>சகோதரர்களின் ஆண் பிள்ளைகள் & பேரன்கள்</li>
              </ul>
            </div>

            {/* Son's Side */}
            <div className="bg-white p-5 rounded-2xl border border-amber-200 shadow-xs">
              <h3 className="font-bold text-[#CC6600] text-sm mb-2 uppercase">மகன் வழி (Son's Lineage):</h3>
              <ul className="list-disc list-inside text-sm text-gray-700 space-y-1.5 leading-relaxed">
                <li>மகன் & மகனின் மகன்கள் (பேரன்கள்)</li>
                <li>கொள்ளுப் பேரன்கள் (7 தலைமுறைக்குட்பட்ட ஆண் சந்ததிகள்)</li>
                <li>10 நாள் பங்காளிகளின் திருமணமான மனைவிகள்</li>
              </ul>
            </div>

          </div>
        </section>

        {/* Section 3: Janana (Birth) Rules */}
        <section className="bg-white p-5 rounded-2xl border border-amber-200 space-y-3">
          <h2 className="text-xl font-bold text-[#1A237E] flex items-center space-x-2">
            <span>👶</span>
            <span>ஜனன (பிறப்பு) தீட்டு முக்கிய நியமங்கள்</span>
          </h2>
          <div className="text-sm text-[#4E342E] space-y-2 leading-relaxed">
            <p>1. <strong>கல்யாணமாகாத ஆண், பெண்</strong> இருபாலருக்கும் ஜனன தீட்டு ஏதும் இல்லை.</p>
            <p>2. பிரசவத்தினால் ஏற்படும் தீட்டு பிரசவித்த 10 நாளுக்குப் பிறகு எவரும் (தாயார் தவிர) காக்கத் தேவையில்லை. பிதாவிற்கும் 10 நாட்களுக்குப் பின் ஸ்நானம் மாத்திரமே.</p>
            <p>3. <strong>சட்டி தொடாமை (சமையலறை கட்டுப்பாடு)</strong>: குழந்தை பெற்ற தாயார் ஆண் குழந்தையானால் 30 நாட்களுக்குப் பிறகும், பெண் குழந்தையானால் 40 நாட்களுக்குப் பிறகே சமையல் மற்றும் வீட்டின் நித்ய பூஜைகளில் ஈடுபட முடியும்.</p>
            <p>4. <strong>தாய்வழி உறவினர்கள்</strong>: குழந்தை பெற்றவளின் பெற்றோருக்கு (மாதாமஹன்/மாதாமஹி) 3 நாட்கள் தீட்டு. சகோதரன், மாமா, பெரியப்பா போன்றவர்களுக்கு தீட்டில்லை (பிரசவச் செலவு ஏற்றவருக்கு 1 நாள் தீட்டு உண்டு).</p>
          </div>
        </section>

        {/* Section 4: Q&A Doubts & Answers Search Results */}
        <section className="space-y-4">
          <div className="flex items-center justify-between border-b border-amber-300 pb-2">
            <h2 className="text-xl font-bold text-[#1A237E] flex items-center space-x-2">
              <span>❓</span>
              <span>ஆசௌச சந்தேகங்களும் ஆசார்ய தீர்வுகளும் (Q&A)</span>
            </h2>
            <span className="text-xs font-bold text-[#1A237E] bg-amber-100 px-3 py-1 rounded-full">
              {filteredQA.length} முடிவுகள்
            </span>
          </div>

          {filteredQA.length === 0 ? (
            <div className="text-center p-8 bg-white rounded-2xl border border-dashed border-amber-300">
              <p className="text-base font-bold text-[#CC6600] mb-1">
                🔍 நீங்கள் தேடிய வார்த்தைக்கு முடிவுகள் எதுவும் கிடைக்கவில்லை.
              </p>
              <p className="text-xs text-gray-600">
                தயவுசெய்து மேலே உள்ள கணிப்பானைப் பயன்படுத்தவும் அல்லது கேள்வி-பதில் பகுதியில் கேள்வி கேட்கவும்.
              </p>
            </div>
          ) : (
            <div className="space-y-3">
              {filteredQA.map((qa) => (
                <div key={qa.id} className="bg-white p-5 rounded-2xl border border-amber-200 shadow-xs hover:border-[#CC6600] transition-colors">
                  <h4 className="font-bold text-[#1A237E] text-base mb-2 flex items-start gap-2">
                    <span className="text-[#CC6600] shrink-0">Q{qa.id}:</span>
                    <span>{qa.q}</span>
                  </h4>
                  <p className="text-sm text-[#4E342E] leading-relaxed bg-[#FAF6EE] p-3 rounded-xl border border-amber-100">
                    <strong className="text-[#1B5E20]">பதில்:</strong> {qa.a}
                  </p>
                </div>
              ))}
            </div>
          )}
        </section>

      </div>
    </div>
  );
};

export default AsouchamPage;
